<template>
  <div>
    <!-- <task-detail @onSave="refreshStages" @onDelete="refreshStages" /> -->

    <task-detail />

    <b-row>
      <b-col md="7" offset-md="2">
        <h1 class="title text-center mb-4">{{ $t("roadmap.kvkk.text") }}</h1>
        <div class="alert alert-info m-4">
          <h6>
            {{ $t("roadmap.init-alert") }}
          </h6>
        </div>
      </b-col>
    </b-row>

    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="KVKK_PRODUCT_ROADMAP" definition="KVKK_PRODUCT_TUTORIAL" :title="$t('roadmap.stage.kvkk-product-tutorial')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="KVKK_PRODUCT_ROADMAP" definition="KVKK_DEPARTMENT_QUESTIONS" :title="$t('roadmap.stage.kvkk-department-questions')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="KVKK_PRODUCT_ROADMAP" definition="KVKK_INVENTORY_UPDATE" :title="$t('roadmap.stage.kvkk-inventory-update')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="KVKK_PRODUCT_ROADMAP" definition="KVKK_POLICY" :title="$t('roadmap.stage.kvkk-policy')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2" class="position-relative">
        <Stage roadmapDefinition="KVKK_PRODUCT_ROADMAP" definition="KVKK_RISK" :title="$t('roadmap.stage.kvkk-risk')" :lines="['center']" />
        <div class="line center"></div>
      </b-col>
    </b-row>
    <!---->
    <b-row>
      <b-col md="7" offset-md="2">
        <Stage roadmapDefinition="KVKK_PRODUCT_ROADMAP" definition="KVKK_REPORT_PREPARE" :title="$t('roadmap.stage.kvkk-report-prepare')" />
      </b-col>
    </b-row>

    <!---->
  </div>
</template>

<script>
import { EventBus } from "@modules/websocket";
import Stage from "./component/roadmap-stage";

export default {
  components: { Stage },
  mounted() {
    const stages = ["KVKK_PRODUCT_TUTORIAL", "KVKK_DEPARTMENT_QUESTIONS", "KVKK_INVENTORY_UPDATE", "KVKK_POLICY", "KVKK_RISK", "KVKK_REPORT_PREPARE"];

    EventBus.$on("task-board-update", (e) => {
      stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });

    EventBus.$on("roadmap-stage-updated", (e) => {
      e.stages.forEach((stage) => {
        this.loadStage(stage);
      });
    });
  },
  methods: {
    // refreshStages(item) {
    //   setTimeout(() => {
    //     const stage = item?.relations?.roadmapStage;
    //     if (stage?.roadmapDefinition == "KVKK_PRODUCT_ROADMAP") {
    //       this.loadStage(stage?.definition);
    //       stage.kvkk-next.forEach((s) => this.loadStage(s));
    //     }
    //   }, 4000);
    // },
    async loadStage(stage) {
      try {
        this.isLoading = true;
        await this.$store.dispatch(`organizationRoadmap/loadStage`, { roadmap: "KVKK_PRODUCT_ROADMAP", stage });
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "./roadmap";
</style>
